/**
 * Attendance Configuration Service
 * HTTP operations for attendance configuration
 */

import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import type { LC_AttendanceConfigurationResponse, LC_UpdateAttendanceConfigurationIn, AttendanceConfiguration } from '../types';
import { mapAttendanceConfiguration } from '../mappers';


export class AttendanceConfigurationService {
  /**
   * Get attendance configuration
   * GET /v{version}/attendance/configuration
   */
  async getConfiguration(): Promise<ApiResponse<AttendanceConfiguration>> {
    const endpoint = API_CONFIG.ENDPOINTS.ATTENDANCE.CONFIGURATION;
    const response = await apiClient.get<LC_AttendanceConfigurationResponse>(endpoint);

    if (!response.success || !response.data) {
      return { ...response, data: null };
    }

    const { configuration, attendanceMarkParameters, overtimeApprovalFlowRoles } = response.data;

    return {
      ...response,
      data: mapAttendanceConfiguration(
        configuration,
        attendanceMarkParameters ?? [],
        overtimeApprovalFlowRoles ?? [],
      ),
    };
  }

  /**
   * Update attendance configuration
   * PUT /v{version}/attendance/configuration
   */
  async updateConfiguration(input: LC_UpdateAttendanceConfigurationIn): Promise<ApiResponse<void>> {
    const endpoint = API_CONFIG.ENDPOINTS.ATTENDANCE.CONFIGURATION;
    return apiClient.put<void>(endpoint, input);
  }
}

export const attendanceConfigurationService = new AttendanceConfigurationService();
